import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { ItemControllerBasePointInput } from '.';
import { CONTROL_ACTIONMODE } from '../Constants';

export default class ItemControllerRoofPointInput extends ItemControllerBasePointInput {
    inputShape: SVGElement;

    /**
     * コンストラクタ
     */
    constructor() {
      super();
      this.type = 'roof';
    }

    followMouseHandler() {
      // 前の点として保管
      let previousPoint;

      if (this.dotList !== null && this.dotList.length > 0) {
        previousPoint = this.dotList[this.dotList.length - 1];
      }

      let newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
      const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;

      if (previousPoint !== undefined && previousPoint !== null) {
        const point1: marietta.core.Point = new marietta.core.Point(previousPoint.x, newPoint.y);
        const point2: marietta.core.Point = new marietta.core.Point(newPoint.x, previousPoint.y);
        const distance1: number = marietta.core.Point.distance(newPoint, point1);
        const distance2: number = marietta.core.Point.distance(newPoint, point2);
        if (distance1 < distance2) {
          newPoint = new marietta.core.Point(previousPoint.x, newPoint.y);
        } else {
          newPoint = new marietta.core.Point(newPoint.x, previousPoint.y);
        }
      }
      this.spt.x = Math.round(newPoint.x / snapUnit) * snapUnit;
      this.spt.y = Math.round(newPoint.y / snapUnit) * snapUnit;
      this.spt.update();

      // 最後のラインの伸び縮
      if (this.currentLine !== undefined) {
        this.currentLine.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
        this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
      }

      // マウス場所保持
      this.mousePlace = new marietta.core.Point(this.spt.x, this.spt.y);
    }

    /**
     * 形状作成の終了
     */
    endMakeShape() {
      // マウスの追従終了
      this.stopFollowMouse();

      // 面積ゼロならアイテムを作成しない
      if (marietta.webcad.util.WebCADUtil.calculateArea(this.dotList) > 0) {
        const dialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoofTypeSelection, true, true, false) as marietta.webcad.view.dialog.RoofTypeSelection;

        // アイテム情報の作成
        let dot: marietta.webcad.collection.PointCollection;
        const info: marietta.webcad.collection.ItemInfoCollection = new marietta.webcad.collection.ItemInfoCollection();
        info.guid = marietta.webcad.WebCADGlobal.getGuid();
        info.x = 0; // this.dotList[0].x;
        info.y = 0; // this.dotList[0].y;
        info.id = 'rof01_01';
        info.dotList = [];
        for (let i: number = 0; i < this.dotList.length; i += 1) {
          dot = new marietta.webcad.collection.PointCollection(this.dotList[i].x, this.dotList[i].y);
          dot.type = 0; // 軒
          dot.guid = marietta.webcad.WebCADGlobal.getGuid();
          info.dotList.push(dot);
        }
        dialog.info = info;
      }

      // 作成用モジュールなど削除する
      this.viewObj.remove();
      if (this.dotImage !== undefined) this.dotImage.remove();
      if (this.inputShape !== undefined) this.inputShape.remove();

      if (this.callbackOnComplete) {
        this.callbackOnComplete();
      }

      // カーソルを元に戻す
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    }

    /**
     * キャンセル処理などに実行
     */
    stopFollowMouse(): void {
      // シェイプを削除
      if (this.inputShape !== undefined && this.inputShape !== null) {
        this.tarLayer.viewObj.removeChild(this.inputShape);
        this.inputShape = null;
      }

      // オーバーライドもとの実行
      super.stopFollowMouse();
    }

    /**
     * 頂点が入力された
     */
    onPointInput(): void {
      if (this.dotList.length < 3) return;

      // 初期化
      if (this.inputShape === undefined || this.inputShape == null) {
        this.inputShape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.inputShape.setAttribute('fill', '#3598DC');
        this.inputShape.setAttribute('opacity', '0.5');
        this.inputShape.setAttribute('id', 'controller_roofInput_shape');
        this.tarLayer.viewObj.appendChild(this.inputShape);
      }

      const tempDotList: marietta.core.Point[] = [];
      for (let i: number = 0; i < this.dotList.length; i += 1) {
        tempDotList.push(new marietta.core.Point(this.dotList[i].x, this.dotList[i].y));
      }
      tempDotList.push(new marietta.core.Point(this.dotList[0].x, this.dotList[0].y));
      this.inputShape.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(tempDotList));
    }

    /**
     * 最後の入力点の削除
     */
    cancelPreviousDot() {
      // 最終ポイントを削除して、描画しなおす
      this.dotList.splice(this.dotList.length - 1, 1);

      // 中身を空にする
      this.dotImage.removeChildren();

      // シェイプをなくす
      if (this.inputShape !== undefined && this.inputShape !== null) {
        this.tarLayer.viewObj.removeChild(this.inputShape);
        this.inputShape = null;
      }

      // 描画しなおす
      this.currentLine = undefined;
      this.currentText = undefined;
      for (let i: number = 0; i < this.dotList.length; i += 1) {
        this.makeDotAt(this.dotList[i]);
      }
    }

    /**
     * ドットの作成
     * @param MouseEvent
     */
    makeDotAt(newPoint: marietta.core.Point) {
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;

      // 前のライン類の終点指定
      if (this.currentLine !== undefined) {
        this.currentLine.secondDot = newPoint;
        this.currentText.secondDot = newPoint;
      }

      // 頂点の作成
      const _dot: Element = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
      _dot.setAttribute('cx', '0');
      _dot.setAttribute('cy', '0');
      _dot.setAttribute('rx', '3');
      _dot.setAttribute('ry', '3');
      _dot.setAttribute('fill', '#000000');
      _dot.setAttribute('id', `dot${this.dotList.length}`);
      const dot: SVGSprite = new SVGSprite(_dot);

      // ドットイメージの作成
      this.dotImage.addChild(dot);
      dot.x = newPoint.x;
      dot.y = newPoint.y;
      dot.update();

      // ラインの作成
      this.currentLine = new marietta.webcad.control.parts.StrechLine(this.dotImage, this.dotList.length);
      this.currentLine.firstDot = newPoint;
      if (ua.isPC) {
        this.currentLine.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
      } else {
        this.currentLine.secondDot = newPoint;
      }

      // テキスト
      this.currentText = new marietta.webcad.control.parts.StrechLineText(this.dotImage, this.dotList.length);
      this.currentText.firstDot = newPoint;
      this.currentText.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);

      // 入力後のアクション
      this.onPointInput();
    }
}
